import React from 'react';

const Background = () => {
  return (
    <div className="site-bg" aria-hidden>
      <div className="bg-orb bg-orb-a" />
      <div className="bg-orb bg-orb-b" />
      <div className="bg-orb bg-orb-c" />
    </div>
  );
};

export default Background;
